// Components - UI
import ReviewStars from '@/components/ui/ReviewStars/ReviewStars.vue';
import IssueCount from '@/components/ui/IssueCount/IssueCount.vue';
import WashroomIcon from '@/components/ui/WashroomIcon/WashroomIcon.vue';

// Services
import ServiceRelationshipsService from '@/services/ServiceRelationshipsService.js';
import SubscriptionsService from '@/services/SubscriptionsService.js';
import MultisitesService from '@/services/MultiSitesService.js';
import WashroomsService from '@/services/WashroomsService.js';
import RetailersService from '@/services/RetailersService.js';
import ReviewsService from '@/services/ReviewsService.js';
import IssuesService from '@/services/IssuesService.js';

// Mixins
import StaggerEntranceTransition from '@/components/mixins/StaggerEntranceTransition/StaggerEntranceTransition.vue';

// EventBus
import { EventBus } from '@/EventBus.js';

export default {

  name: 'Washrooms',

  mixins: [
    StaggerEntranceTransition
  ],

  components: {
    ReviewStars,
    IssueCount,
    WashroomIcon
  },

  data: function() {
    return {
      userGroup: localStorage.getItem('userGroup'),
      pageTitle: null,
      washrooms: [],
      retailer: null,
      searchTerm: null,
      showSearch: false,

      // Add washroom
      addMode: false,
      newWashroom: {
        name: null,
        facilityType: 'select'
      }
    }
  },

  created: function() {
    this.init();
  },

  mounted: function() {

  },

  beforeDestroy: function() {

  },

  methods: {
    init: function() {
      // Reset component data
      this.washrooms = [];
      this.retailer = null;

      let filter = {};

      if(this.$route.params.retailerId) {
        // Get Multisite name as page title
        RetailersService.getById(this.$route.params.retailerId)
          .then((res) => {
            this.pageTitle = res.data.name;
          })
          .catch((err) => {});

        filter = {
          retailer: this.$route.params.retailerId
        };

        this.getWashrooms(filter);
      }
      // If we are logged in as a retailer
      else if(localStorage.getItem('userGroup') == 'retailers') {
        filter = {
          retailer: localStorage.getItem('parentId') // In this case 'parentID' is the logged in retailer's id
        };

        this.getWashrooms(filter);
      }
      // If we are logged in as a multi-site retailer
      else if(localStorage.getItem('userGroup') == 'multi-site-retailers') {
        RetailersService.getAll({multiSite: localStorage.getItem('parentId') }) // In this case 'parentID' is the logged in multi-site-retailer's id
          .then((res) => {
            filter = [];

            for (let i in res.data) {
              filter.push({retailer: res.data[i].id});
            }

            this.getWashrooms(filter, 'or');
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          });
      }
      // If we are logged in as a service provider
      else if(localStorage.getItem('userGroup') == 'service-providers') { // If we are logged in as a service provider
        ServiceRelationshipsService.getAll({serviceProvider: localStorage.getItem('parentId')})
          .then((res) => {
            let retailerIds = [];
            let filter = [];
            let filterMode = 'or';

            // Get DISTINCT ids of retailers that this SP services
            for(let i in res.data) {
              if(res.data[i].retailer && res.data[i].retailer.id) {
                if(retailerIds.indexOf(res.data[i].retailer.id) == -1) {
                  retailerIds.push(res.data[i].retailer.id);
                  filter.push({retailer: res.data[i].retailer.id});
                }
              }
            }

            if(filter.length > 0) {
              this.getWashrooms(filter, filterMode);
            }
          })
          .catch((err) => {
            EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
          });
      }
      else {
        this.getWashrooms();
      }

      // If we have a retailer ID, fetch the retailer for populating the header
      if (filter.retailer) {
        RetailersService.getById(filter.retailer)
          .then((res) => {
            this.retailer = res.data;
          });
      }
    },

    getWashrooms: function(filter, filterMode) {
      if (this.$route.params.multisiteId) {
        // Get Multisite name as page title
        MultisitesService.getById(this.$route.params.multisiteId)
          .then((res) => {
            this.pageTitle = res.data.name;
          })
          .catch((err) => {});

        // Load washrooms for the multisite id
        WashroomsService.getByMultisiteId(this.$route.params.multisiteId, filter, filterMode)
        .then((res) => {
          this.populateWashroomData(res);
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
      }
      else {
        // Load all the washrooms
        WashroomsService.getAll(filter, filterMode)
        .then((res) => {
          this.populateWashroomData(res);
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! Something went wrong, please try again.');
        });
      }
    },

    populateWashroomData: function(res) {
      for (let i in res.data) {
        res.data[i].issues = [];
      }

      // Store washroom data
      this.washrooms = res.data;

      // Loop through washrooms adding additional data
      for (var i = 0; i < this.washrooms.length; i++) {

        // Create a variable storing the washroom to be used in promises
        let washroom = this.washrooms[i];

        // Get Retailer
        RetailersService.getById(washroom.retailer)
          .then((res) => {
            // Add retailerData onto the washroom
            this.$set(washroom,'retailerData',res.data);
          });

        let issuesFilter = { washroom: washroom.id };

        if(localStorage.getItem('userGroup') == 'service-providers') {
          issuesFilter.serviceProvider = localStorage.getItem('parentId');

          issuesFilter.status = ['confirmed', 'resolution-in-progress', 'resolution-awaiting-approval', 'resolution-denied'];
        }

        // Get Issues for Washroom
        IssuesService.getAll(issuesFilter)
          .then((res) => {
            // Add retailerData onto the washroom
            this.$set(washroom,'issues',res.data);
          });

        // Get Review Stats for Washroom
        WashroomsService.getReviewStats(washroom.id)
          .then((res) => {
            // Add reviewStats onto the washroom
            this.$set(washroom,'reviewStats',res.data);
          });
      }
    },

    openSearch: function() {
      this.showSearch = true;

      // Wait for element visible before focus
      setTimeout(() => {
        this.$refs.searchInput.focus();
      }, 200);
    },

    closeSearch: function() {
      this.searchTerm = null;
      this.showSearch = false;
    },

    cancelNewWashroom: function() {
      this.addMode = false;
      this.newWashroom = {
        name: null,
        facilityType: 'select'
      };
    },

    saveNewWashroom: function() {
      // Validate input
      if((this.newWashroom.name == null || this.newWashroom.name.trim() == '') || this.newWashroom.facilityType == 'select') {
        EventBus.dispatchErrorEvent('Please provide both a washroom name and type before attempting to save.');
      }
      // Save new Washroom
      else {
        SubscriptionsService.getAll({retailer: localStorage.getItem('parentId')})
        .then((res) => {
          if(res.data.length > 0)
          {
            let subscriptionPackage = res.data[0].package;
            let maxWashrooms = SubscriptionsService.packages[subscriptionPackage].maxWashrooms;

            if(this.search.length < maxWashrooms) {
              let newWashroom = {
                name: this.newWashroom.name,
                facilityType: this.newWashroom.facilityType,
                retailer: localStorage.getItem('parentId')
              };

              WashroomsService.createOne(newWashroom)
              .then((res) => {
                this.addMode = false;
                this.newWashroom = {
                  name: null,
                  facilityType: 'select'
                };
                this.init();
              })
              .catch((err) => {
                EventBus.dispatchErrorEvent('Whoops! Something went wrong adding the washroom, please try again.');
              });
            }
            else {
              EventBus.dispatchErrorEvent('Washroom limit reached, to increase your limit please upgrade your package.');
            }
          }
          else {
            EventBus.dispatchErrorEvent('We couldn\'t find a valid subscription for this account, please try again.');
          }
        })
        .catch((err) => {
          EventBus.dispatchErrorEvent('Whoops! There was a problem communicating with the server, please try again.');
        });
      }
    }
  },

  computed: {
    search: function() {
      if(this.searchTerm && this.searchTerm.trim().length > 0) {
        return this.washrooms.filter((w) => {
          if (w.name.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1  || w.retailerData.address.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1 || w.retailerData.city.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1 || w.retailerData.postcode.toLowerCase().trim().indexOf(this.searchTerm.toLowerCase().trim()) > -1) {
            return true;
          }

          return false;
        });
      }
      else {
        return this.washrooms;
      }
    }
  },

  watch: {
    '$route' (to, from) {
      this.init();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Washrooms/Washrooms.js